import React from "react";
import SecondaryButton from "./UI/SecondaryButton";
import BackButton from "./UI/BackButton";
import { useSelector } from "react-redux";
import { LuChevronRight } from "react-icons/lu";

const FormControl = ({
  activeStep,
  handleBack,
  handleNext,
  isDesktop,
  isLoading,
  exitRef
}) => {
  const isEdit = useSelector((state) => state.isEdit)
  return (
    <div
      className={`${isDesktop ? "w-[83.5%]" : "w-full"
        } fixed bottom-0 bottom_controls h-[60px] lg:h-[57px] bg-[#fdfcfb]`}
    >
      {/* <hr className="h-[1px] border-none bg-black opacity-30" /> */}
      <div className="flex justify-between px-4 py-2">
        <BackButton
          text={"Back"}
          classes={`${activeStep == 0 && "invisible"} underline`}
          handleClick={handleBack}
        ></BackButton>
        <div className="flex items-center gap-2">
          {isEdit && activeStep !== 5 && <button
            // type="submit"
            type="button"
            onClick={(e) => {
              exitRef.current = true
              e.target.closest('form').requestSubmit();
            }}
            disabled={isLoading}
            className="text-white bg-[#045540] h-8 lg:h-10 font-semibold px-8 text-sm lg:text-base lg:px-16 py-2 my-0 rounded-lg"
          >
          
            {isLoading && exitRef.current ? (
              <div className="px-3">
                <div className="dots"></div>
              </div>
            ) : (
             'Save'
            )}
          </button>}
          <button
            type="submit"
            disabled={isLoading}
            className="text-white bg-[#045540] h-8 lg:h-10 font-semibold text-sm lg:text-base px-8 lg:px-14 py-2 my-0 rounded-lg"
          >
            {isLoading && !exitRef.current ? (
              <div className="px-3">
                <div className="dots"></div>
              </div>
            ) : (
              activeStep !== 5 ? <div className="flex items-center gap-1">Save & Continue <LuChevronRight size={18} /></div> : "Launch"
            )}
          </button>


        </div>
      </div>
    </div>
  );
};

export default FormControl;
